import React, { useEffect } from 'react';
import { useGate, useStore } from 'effector-react';
import type { CFModel3D, LibItemModal3d } from '@types';
import { HOST } from '@constants';
import Title from '@components/Title';
import Button from '@components/Button';
import Icon from '@components/Icon';
import SearchBar from '../components/SearchBar';
import FooterClear from '../components/FooterClear';
import LibModalNav from '../layouts/LibModalNav';
import LibModal from '../layouts/LibModal';
import {
  LibAddedModel3dGate,
  LibItemsGate,
  LibMultipleGate,
} from '../stores/libState';
import libReset from '../actions/libReset';
import { $libSelected } from '../stores/libSelected';
import ListModel3d from './ListModel3d';
import Tip from './Tip';
import ImgAdd from './img-add.png';

type Props = {
  multiple?: boolean;
  addTids?: Set<string>;
  onConfirm: (result: { tids?: CFModel3D['modelTids'] }) => void;
  onRequestClose: () => void;
};

function LibModel3dModal({
  multiple = false,
  addTids = new Set(),
  onConfirm,
  onRequestClose,
}: Props) {
  useGate(LibMultipleGate, multiple);
  useGate(LibAddedModel3dGate, addTids);
  useEffect(() => libReset, []);
  const noSelected = !useStore($libSelected).length;

  const handleConfirm = () => {
    const selected = $libSelected.getState();
    const tids = (LibItemsGate.state.getState() as LibItemModal3d[])
      .filter((x) => selected.includes(x.id))
      .sort((a, b) => selected.indexOf(a.id) - selected.indexOf(b.id))
      .map((x) => x.tid);
    onConfirm({ tids });
  };

  return (
    <LibModal
      header={
        <>
          <Title>3D模型作品</Title>
          <SearchBar />
          <Button
            className="ml-auto"
            as="a"
            href={`${HOST}/my/3dmodel/task`}
            target="_blank"
          >
            <Icon className="mr-5" src={ImgAdd} />
            <span>创建3D模型</span>
          </Button>
        </>
      }
      footer={
        <>
          <Button disabled={noSelected} onClick={handleConfirm}>
            确认操作
          </Button>
          <FooterClear />
        </>
      }
      onRequestClose={onRequestClose}
    >
      <LibModalNav
        navItems={[{ id: 'lib', name: '3D模型' }] as const}
        selected="lib"
      >
        <Tip />
      </LibModalNav>
      <ListModel3d />
    </LibModal>
  );
}

export default LibModel3dModal;
